// extracted by mini-css-extract-plugin
export default {"conditionsPrependText":"EmailEditCreatePage-module_conditionsPrependText_AzlqTI"};